import V3ApiService from "./V3ApiService";
import ApiService from "./ApiService";
import AnonymousV3ApiService from "./AnonymousV3ApiService";

export default function createApiService(
    dbToken: string,
    jwt: string,
    apiVersion: string = 'mock',
    apiUrl: string = '',
    appContext: string,
    routeChangeFunc: any = undefined,
    login = false,
    walleyApiUrl: string = '',

): ApiService {
  if(appContext !== "production") {
    console.log('createApiService', dbToken ? 'token_set' : 'none', '-', jwt ? 'jwt_set' : 'none', '-', apiUrl);
  }

  if(jwt || login)
    return new V3ApiService(dbToken, jwt, apiUrl, routeChangeFunc, walleyApiUrl);
  else return new AnonymousV3ApiService(dbToken, jwt, apiUrl, routeChangeFunc, walleyApiUrl);
}
